import "swiper/dist/css/swiper.css";
import mediasMixins from "root/mixins/mediasMixin.js";
import utilsMixin from "root/mixins/utilsMixin.js";
import quickProductMixin from "root/mixins/quickProductMixin.js";

import closeImage from "assets/img/svg/close.svg";
import heartOff from "assets/img/svg/heart-regular.svg";
import heartOn from "assets/img/svg/heart-solid.svg";
import empaqueImage from "assets/img/svg/empaque.svg";
import tiendaImage from "assets/img/svg/tienda.svg";
import empaqueGrayImage from "assets/img/svg/empaque-gray.svg";
import tiendaGrayImage from "assets/img/svg/tienda-gray.svg";
import iconPlus from "assets/img/svg/plus.svg";
import iconMinus from "assets/img/svg/minus.svg";
import iconShoppingBag from "assets/img/svg/shoppingbag.svg";
import solidArrow from "assets/img/svg/solid-arrow.svg";
const axios = require("axios");
import wishlistMixin from "root/mixins/wishlistMixin.js";

import { Tabs, Tab } from "vue-tabs-component";

export default {
  name: "product-lister-grid-item",
  mixins: [mediasMixins, utilsMixin, quickProductMixin, wishlistMixin],
  components: {
    Tab,
    Tabs,
  },

  props: ["product", "iswishlist", "isLoggedIn", "breadcrumbs"],

  data() {
    const vue = this;
    return {
      iconPlus: iconPlus,
      iconMinus: iconMinus,
      iconShoppingBag: iconShoppingBag,
      solidArrow: solidArrow,
      itemQuantity: 1,
      modalReferenceHtml: "",
      modalReferenceShow: false,
      closeImage: closeImage,
      heartOff: heartOff,
      heartOn: heartOn,
      showQuickButton: false,
      quickHasDeliveryPickup: false,
      quickDeliveryStandard: false,
      empaqueImage: empaqueImage,
      tiendaImage: tiendaImage,
      tiendaGrayImage: tiendaGrayImage,
      empaqueGrayImage: empaqueGrayImage,
      quickProduct: null,
      urlprefix: "p/",
      isLoading: false,
      CSRFToken: vue.$root.CSRFToken,

      quickvariantsswiperoptions: {
        spaceBetween: 10,
        preloadImages: true,
        navigation: {
          nextEl: ".quick-variants-button-next",
          prevEl: ".quick-variants-button-prev",
        },
        slidesPerView: 7,
        breakpoints: {
          1023: {
            slidesPerView: 5,
          },
        },
      },
    };
  },

  methods: {
    buildUrl() {
      let concatBreadcrumbs = "";

      this.breadcrumbs.forEach((crumb) => {
        if (concatBreadcrumbs) {
          concatBreadcrumbs = concatBreadcrumbs + "-" + crumb.categoryCode;
        } else {
          concatBreadcrumbs = crumb.categoryCode;
        }
      });

      if (!concatBreadcrumbs) {
        return this.product.url;
      }

      const productUrl = `${this.product.url}?breadcrumbs=${concatBreadcrumbs}`;

      return productUrl;
    },

    showQuickButtonAction() {
      this.showQuickButton = true;
    },

    hideQuickButtonAction() {
      this.showQuickButton = false;
    },

    bindChildCloseModal() {
      var $this = this;
      this.$on("closeReferenceModal", function() {
        $this.modalReferenceShow = false;
      });
    },

    isInWishList() {
      this.wishtListVar = this.$root.wishlistentries;
      if (this.wishtListVar) {
        this.wishListBoolean = this.wishtListVar.some(
          (entry) => entry.product.code === this.product.code
        );
      }
    },

    deleteWishlistPage(productCode) {
      if (this.isLoggedIn) {
        axios({
          method: "get",
          url: "/wish/remove",
          params: {
            productCode: productCode,
          },
        }).then((response) => {
          if (response.status === 200) {
            window.location.reload();
          }
        });
      } else {
        window.location.href = "/login";
      }
    },
  },

  computed: {
    productreferences: function() {
      var productreferences = this.isJson(this.rawproductreferences);
      _.each(productreferences, function(product) {
        product.target.coverImage = _.find(product.target.images, function(
          img
        ) {
          return img.format === "product";
        });
      });
      return productreferences;
    },
    rawProductName() {
      let regex = /(<([^>]+)>)/gi;
      return this.product.name.replace(regex, "");
    },
    imageToShow() {
      return _.find(this.product.images, function(image) {
        return image.format === "product";
      });
    },
    installmentCreditoDirecto() {
      if (!this.product.installmentCreditoDirecto) {
        return false;
      }
      var splitted = this.product.installmentCreditoDirecto.split("|");
      return (
        this.product.installmentCreditoDirecto && {
          qty: splitted[0],
          amount: splitted[1],
          total: splitted[2],
        }
      );
    },
  },

  mounted: function() {
    this.bindChildCloseModal();
  },
};



// WEBPACK FOOTER //
// ./web/webroot/_ui/responsive/common/js/src/components/product/productlistergriditem/productlistergriditem.js